import { render, staticRenderFns } from "./RepresentativeSettings.vue?vue&type=template&id=44785096&scoped=true"
import script from "./RepresentativeSettings.vue?vue&type=script&lang=js"
export * from "./RepresentativeSettings.vue?vue&type=script&lang=js"
import style0 from "./RepresentativeSettings.vue?vue&type=style&index=0&id=44785096&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44785096",
  null
  
)

export default component.exports